import React, {useContext, useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import MainContext from "../Components/Contexts/MainContext";
import { useTranslation } from "react-i18next";

const Navdata = () => {
  // #333 (2026-10-12): every label comes from the "menu" namespace, keyed by the item's id
  // (src/locales/{tr,en}/menu.json). WAS: label: "<Turkish text>".
  const { t } = useTranslation("menu");
  const history = useNavigate();
  const { setMenuItemClicked } = useContext(MainContext);
  const [isDashboard, setIsDashboard] = useState(false);
  const [isModuller, setIsModuller] = useState(false);
  const [isBetterStands, setIsBetterStands] = useState(false);
  const [isConfigurations, setIsConfigurations] = useState(false);
  const [isEmails, setIsEmails] = useState(false);
  const [isISG, setIsISG] = useState(false);
  const [isElektrik, setIsElektrik] = useState(false);
  const [isAcilDurum, setIsAcilDurum] = useState(false);
  const [isConstantElektrik, setIsConstantElektrik] = useState(false);
  const [isLogistics, setIsLogistics] = useState(false);
  const [isJobPermission, setIsJobPermission] = useState(false);
  const [isFairs, setIsFairs] = useState(false);
  const [isManagement, setIsManagement] = useState(false);
  const [isFirmalar, setIsFirmalar] = useState(false);
  // #450: the company portal's "Organizatör" parent (one entry per area underneath).
  const [isOrganizator, setIsOrganizator] = useState(false);
  // #385: "Kişiler" artık açılan bir grup değil, Kişi Listesi'ne giden düz bir bağlantı — isKisi durumu kalktı.
  // Meslek / künye kuralları Sistem Ayarları › Kişi Kuralları'nda. WAS: const [isKisi, setIsKisi] = useState(false);
  // Salonlar ve Krokiler — salon taban planı grubu. "Salonlar" (seçili fuarın fuar alanına
  // ait salonları bu fuara bağlar/çıkarır) backlog #157 ile geldi, 2026-09-23 — WAS rezerve.
  const [isSalonlarKrokiler, setIsSalonlarKrokiler] = useState(false);
  const [isSahaModulu,   setIsSahaModulu]   = useState(false);
  const [isForms,        setIsForms]        = useState(false);
  const [isFdsDenetim,        setIsFdsDenetim]        = useState(false);
  // Form Yönetimi — bağımsız üst menü
  const [isFormYonetimi,      setIsFormYonetimi]      = useState(false);
  // Diğer Formlar — Form Yönetimi altındaki ikinci seviye açılır grup
  // (Serbest Formlar + Sürdürülebilirlik Formu). 2026-09-12'de "Esnek Formlar" ve
  // "Sürdürülebilirlik" bağımsız üst menülerinin yerini aldı.
  const [isDigerFormlar,      setIsDigerFormlar]      = useState(false);
  // Sistem Ayarları — menünün EN ALTINDA, günlük işten uzakta. Buradaki tek şey
  // global kural şablonu; bilinçli olarak Projeler'in yanına konmadı (bkz.
  // GlobalKurallarPage.jsx dosya başı: yanlış kapsamda kaydetmeyi zorlaştırmak).
  const [isSistemAyarlari,    setIsSistemAyarlari]    = useState(false);
  // #585: E-posta menüsü (kayıtlar, şablonlar, posta listeleri, hesaplarım)
  const [isEmailMenusu,        setIsEmailMenusu]       = useState(false);

  // FdsSaha varsayılan açık
  const [iscurrentState, setIscurrentState] = useState("FdsSaha");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  function handleMenuItemClick(e){
    setMenuItemClicked(true);
  }

  useEffect(() => {
    async function run() {
      document.body.classList.remove("twocolumn-panel");
      // ─ twocolumn-panel kaldırıldı: sidebar sayfa açılışında tam genişlikte görünsün ─
      // if (iscurrentState !== "Dashboard") {
      //   document.body.classList.add("twocolumn-panel");
      //   setIsDashboard(false);
      // }
      if (iscurrentState !== "Moduller") {
        setIsModuller(false);
      }
      if (iscurrentState !== "SahaModulu") {
        setIsSahaModulu(false);
      }
      if (iscurrentState !== "Management") {
        setIsManagement(false);
      }
      if (iscurrentState !== "Firmalar") {
        setIsFirmalar(false);
      }
      if (!String(iscurrentState).startsWith("FirmaOrganizator") && iscurrentState !== "FirmaKroki") {
        setIsOrganizator(false);
      }
      if (iscurrentState !== "Fuarlar") {
        setIsFairs(false);
      }
      if (iscurrentState !== "SalonlarKrokiler") {
        setIsSalonlarKrokiler(false);
      }
      if (iscurrentState !== "FormYonetimi") {
        setIsFormYonetimi(false);
        setIsDigerFormlar(false);   // üst menü kapanınca alt grup da kapansın
      }
      if (iscurrentState !== "EmailMenusu") {
        setIsEmailMenusu(false);
      }
    }
    run();
  }, [
    history,
    iscurrentState,
      isDashboard,
      isModuller,
      isSahaModulu,
        isManagement,
        isFairs,
        isFirmalar,
        isOrganizator,
        isSalonlarKrokiler,
        isFormYonetimi,
        isDigerFormlar,
        isSistemAyarlari,
        isEmailMenusu,
  ]);

  const menuItems = [
    // ─── FİRMA ANA SAYFA — sadece grup 9 (Firma Moderatör) ve 19 (Firma Admin) için
    // görünür (MainContext.js api.groups[9|19].visibleItems = ['FirmaAnaSayfa']) ────
    {
      id: "FirmaAnaSayfa",
      label: t("FirmaAnaSayfa"),
      icon: "bx bxs-home",
      link: "/Firma/Anasayfa",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaAnaSayfa");
        handleMenuItemClick(e);
      },
    },
    // ─── FİRMA KARTI — grup 9/19 için Ana Sayfa'nın yanında ikinci menü öğesi
    // (MainContext.js api.groups[9|19].visibleItems = ['FirmaAnaSayfa', 'FirmaKart', 'FirmaStandlar']) ─
    {
      id: "FirmaKart",
      label: t("FirmaKart"),
      icon: "bx bx-id-card",
      link: "/Firma/FirmaKart",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaKart");
        handleMenuItemClick(e);
      },
    },
    // ─── FİRMA STANDLARIM — grup 9/19 için üçüncü menü öğesi, Ana Sayfa'daki
    // "İnşa İzin Durumu" / "Proje Evrakları Durumu" panellerindeki "Tümünü Gör"
    // bağlantılarının açtığı tam müşteri-stand listesiyle aynı sayfa ────
    {
      id: "FirmaStandlar",
      label: t("FirmaStandlar"),
      icon: "bx bxs-store",
      link: "/Firma/Standlar",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaStandlar");
        handleMenuItemClick(e);
      },
    },
    // ─── FİRMA TALEPLER — grup 9/19 için dördüncü menü öğesi, standlarım genelindeki
    // Genel Talepler + İş İzinleri'nin birleşik listesi (MainContext.js
    // api.groups[9|19].visibleItems = firmaVisibleItems = [..., 'FirmaTalepler']) ─
    {
      id: "FirmaTalepler",
      label: t("FirmaTalepler"),
      icon: "bx bx-list-ul",
      link: "/Firma/Talepler",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaTalepler");
        handleMenuItemClick(e);
      },
    },
    // ─── FİRMA PROJELER — grup 9/19 için beşinci menü öğesi, standlarım genelindeki
    // proje evrakları/taahhütname durumunun kart görünümü (MainContext.js
    // api.groups[9|19].visibleItems = firmaVisibleItems = [..., 'FirmaProjeler']) ─
    {
      id: "FirmaProjeler",
      label: t("FirmaProjeler"),
      icon: "bx bx-building-house",
      link: "/Firma/Projeler",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaProjeler");
        handleMenuItemClick(e);
      },
    },
    // ─── FİRMA PERSONEL — grup 9/19 için altıncı menü öğesi, Ana Sayfa'daki
    // "Kurulum ve Söküm Kartı Durumu" panelindeki "Tüm Personeller" bağlantısının
    // açtığı tam personel listesi (MainContext.js api.groups[9|19].visibleItems =
    // firmaVisibleItems = [..., 'FirmaPersonel']) ─
    {
      id: "FirmaPersonel",
      label: t("FirmaPersonel"),
      icon: "bx bx-user-pin",
      link: "/Firma/Personel",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaPersonel");
        handleMenuItemClick(e);
      },
    },
    // (2026-10-06, #300: "Personel Listem" menü öğesi kalktı — daimî liste artık "Personel" sayfasının
    // "Daimî Liste" görünümü; eski /Firma/PersonelListem adresi oraya yönlenir.)
    // ─── TAŞERONLAR — grup 9/19 için sekizinci menü öğesi ────────────────────
    // Dekoratörün bu fuardaki maiyeti + firmayı taşeron gösterenlerin onay kuyruğu.
    // İlişki artık standa değil, dekoratör+fuara çapalı (`firma_taseron`).
    {
      id: "FirmaTaseronlar",
      label: t("FirmaTaseronlar"),
      icon: "bx bx-transfer",
      link: "/Firma/Taseronlar",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaTaseronlar");
        handleMenuItemClick(e);
      },
    },
    // ─── ORGANİZATÖR PANELİ (#321, 2026-10-11) — yalnızca Organizatör arayüzünde ───────────
    // Menü, aktif arayüz setinin modüllerinden süzülür (VerticalLayouts, #311): FIRMA_YONETIMI.
    // #450 (2026-10-17): "Organizatör" artık bir ÜST BAŞLIK; altında her ALAN için bir giriş var ve her giriş yalnızca firmanın o alandaki
    // kademesi İzleme ya da Denetim ise görünür (VerticalLayouts, ORGANIZATOR_ALT_OGELER). Kroki (#322) SALONLAR alanı olarak buranın altına taşındı.
    // WAS (until #450): düz bir giriş { id: "FirmaOrganizator", link: "/Firma/Organizator" } ve ayrı bir üst düzey "FirmaKroki" girişi.
    {
      id: "FirmaOrganizator",
      label: t("FirmaOrganizator"),
      icon: "bx bx-buildings",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsOrganizator(!isOrganizator);
        setIscurrentState("FirmaOrganizator");
        updateIconSidebar(e);
      },
      stateVariables: isOrganizator,
      subItems: [
        { id: "FirmaOrganizatorStandlar", label: t("FirmaOrganizatorStandlar"), link: "/Firma/Organizator/Standlar", parentId: "FirmaOrganizator", click: handleMenuItemClick },
        { id: "FirmaOrganizatorFirmalar", label: t("FirmaOrganizatorFirmalar"), link: "/Firma/Organizator/Firmalar", parentId: "FirmaOrganizator", click: handleMenuItemClick },
        { id: "FirmaOrganizatorTalepler", label: t("FirmaOrganizatorTalepler"), link: "/Firma/Organizator/Talepler", parentId: "FirmaOrganizator", click: handleMenuItemClick },
        { id: "FirmaOrganizatorProjeler", label: t("FirmaOrganizatorProjeler"), link: "/Firma/Organizator/Projeler", parentId: "FirmaOrganizator", click: handleMenuItemClick },
        { id: "FirmaOrganizatorKisiler",  label: t("FirmaOrganizatorKisiler"),  link: "/Firma/Organizator/Kisiler",  parentId: "FirmaOrganizator", click: handleMenuItemClick },
        // ─── KROKİ (#322) — organizatörün aktif salonları ve yalnızca görüntüleme krokisi (SALONLAR alanı) ──────
        { id: "FirmaKroki", label: t("FirmaKroki"), link: "/Firma/Kroki", parentId: "FirmaOrganizator", click: handleMenuItemClick },
      ],
    },
    // ─── GEREKLİ BELGELER (#318) — rollere göre hangi belge gerekli ─────────────────────────
    {
      id: "FirmaBelgeGereksinimleri",
      label: t("FirmaBelgeGereksinimleri"),
      icon: "bx bx-list-check",
      link: "/Firma/BelgeGereksinimleri",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaBelgeGereksinimleri");
        handleMenuItemClick(e);
      },
    },
    // ─── FUAR KURALLARI (#536) — onay metinlerinin önizlemesi; yalnızca Katılımcı setlerinde (Yerli + Yabancı), VerticalLayouts ───
    {
      id: "FirmaFuarKurallari",
      label: t("FirmaFuarKurallari"),
      icon: "bx bx-book-content",
      link: "/Firma/FuarKurallari",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("FirmaFuarKurallari");
        handleMenuItemClick(e);
      },
    },
    // ─── KİŞİ KARTIM (prototip) — #385'te kaldırıldı: sayfa, servis ve menü öğesi git geçmişinde (397c213). ───
    // ─── Dashboard — yönlendirme için korunuyor, menüden gizlendi ────────────
    /*
    {
      id: "Dashboard",
      label: t("Dashboard"),
      icon: "bx bxs-home",
      link: "/Dashboard",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Dashboard");
      },
    },
    */
    // ─── Management (Fuar Yönetimi) — yoruma alındı ──────────────────────────
    /*
    {
      id: "Management",
      label: t("Management"),
      icon: "bx bxs-calendar-check",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsManagement(!isManagement);
        setIscurrentState("Management");
        updateIconSidebar(e);
      },
      stateVariables: isManagement,
      subItems: [
        {
          id: "Fuarlar",
          label: t("Fuarlar"),
          link: "/#",
          parentId: "Management",
          isChildItem: true,
          click: function (e) { e.preventDefault(); },
          childItems: [
            { id: "FuarListesi",  label: t("Fuarlar"),       link: "/Management/Fairs", parentId: "Fuarlar", click: handleMenuItemClick },
            { id: "FuarAlanlari", label: t("FuarAlanlari"), link: "/FairAreas",         parentId: "Fuarlar", click: handleMenuItemClick },
            { id: "Salonlar",     label: t("Salonlar"),      link: "/Management/Fairs", parentId: "Fuarlar", click: handleMenuItemClick },
          ],
        },
        {
          id: "FormYonetimiAlt",
          label: t("FormYonetimiAlt"),
          link: "/#",
          parentId: "Management",
          isChildItem: true,
          click: function (e) { e.preventDefault(); setIsForms(!isForms); },
          stateVariables: isForms,
          childItems: [
            {
              id: "FormListesiAlt",
              label: t("FormListesiAlt"),
              link: "/Management/Forms/list",
              parentId: "FormYonetimiAlt",
              click: handleMenuItemClick,
            },
            {
              id: "HiyerarsiYonetimiAlt",
              label: t("HiyerarsiYonetimiAlt"),
              link: "/Management/Forms/hierarchy",
              parentId: "FormYonetimiAlt",
              click: handleMenuItemClick,
            },
            {
              id: "DenetimKayitlariAlt",
              label: t("DenetimKayitlariAlt"),
              link: "/Management/Forms/instances",
              parentId: "FormYonetimiAlt",
              click: handleMenuItemClick,
            },
          ],
        },
      ],
    },
    */
    // ─── ANA SAYFA — FdsSaha anasayfası, uygulamanın "home"u ─────────────────
    {
      id: "AnaSayfa",
      label: t("AnaSayfa"),
      icon: "bx bxs-home",
      link: "/FdsSaha",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("AnaSayfa");
        handleMenuItemClick(e);
      },
    },
    // ─── FUARLAR ────────────────────────────────────────────────
    // 2026-09-12: menüye geri alındı. İki sayfa da ROTALIYDI ama hiçbir menü girişinden
    // erişilemiyordu (`/Management/Fairs` canlı, `/FairAreas` hâlâ mock).
    // Backlog #50 (2026-09-18): `/FairAreas` artık mock değil — #26 ile canlı
    // `/Management/FairAreas`'a redirect oldu (allRoutes.js).
    // REZERVE: fuar bazında açılacak diğer ekranlar (takvim, fuar ayarları) buraya girecek.
    {
      id: "Fuarlar",
      label: t("Fuarlar"),
      icon: "bx bxs-calendar-check",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsFairs(!isFairs);
        setIscurrentState("Fuarlar");
        updateIconSidebar(e);
      },
      stateVariables: isFairs,
      subItems: [
        { id: "FuarListesi",  label: t("FuarListesi"),  link: "/Management/Fairs",        parentId: "Fuarlar", click: handleMenuItemClick },
        { id: "FuarSerileri", label: t("FuarSerileri"), link: "/Management/Fairs/Series", parentId: "Fuarlar", click: handleMenuItemClick },
        // 2026-09-15: Projeler altındaki "Fuar Kuralları" + "Belge Kuralları" buraya taşındı
        // ve tek sekmeli sayfa oldu; "Talep Türleri" sekmesi de o sayfada. Hepsi SEÇİLİ
        // fuara yazar — fuara özel olduğu için Fuarlar başlığının altında.
        { id: "FuarKurallari", label: t("FuarKurallari"), link: "/Management/Fairs/Rules", parentId: "Fuarlar", click: handleMenuItemClick },
        // 2026-09-15: canlı sayfa (/Management/FairAreas) — liste, ayrı detay sayfası, Salonlar.
        { id: "FuarAlanlari", label: t("FuarAlanlari"), link: "/Management/FairAreas",    parentId: "Fuarlar", click: handleMenuItemClick },
      ],
    },
    // ─── Firmalar ─────────────────────────────────────────────────────────────
    {
      id: "Firmalar",
      label: t("Firmalar"),
      icon: "bx bxs-building",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsFirmalar(!isFirmalar);
        setIscurrentState("Firmalar");
        updateIconSidebar(e);
      },
      stateVariables: isFirmalar,
      subItems: [
        // 2026-09-12: menü tek girişe indi. "Eşlenmiş Firmalar" (mock liste) ve "Fuar
        // Firmaları" aynı soruyu soruyordu — ikisi de Firma Kartları'nın iki bölümü oldu.
        // "Firma Profili İncele" ve "Personel Belgeleri İncele" ise artık bir firmanın
        // Detay sayfasının sekmeleri; menüden değil, karttan giriliyor.
        { id: "FirmaKartlar",   label: t("FirmaKartlar"),   link: "/Management/Firmalar/Kartlar", parentId: "Firmalar", click: handleMenuItemClick },
        // Taşeron kuyruğu menüde KALIYOR: fuar geneli "telefon edilecekler" listesi tek
        // bir firmaya ait değil (aynı ekran Firma Detay'da firmaya daraltılmış hâlde de var).
        { id: "TaseronBaglantilari", label: t("TaseronBaglantilari"), link: "/Management/Firmalar/TaseronBaglantilari", parentId: "Firmalar", click: handleMenuItemClick },
        // #313 / #318 (2026-10-11): yabancı / yerli incelemesi ve rollere göre gerekli belgeler.
        { id: "FirmaUyruklar", label: t("FirmaUyruklar"), link: "/Management/Firmalar/Uyruklar", parentId: "Firmalar", click: handleMenuItemClick },
        { id: "FirmaBelgeGereksinimleriPersonel", label: t("FirmaBelgeGereksinimleriPersonel"), link: "/Firma/BelgeGereksinimleri", parentId: "Firmalar", click: handleMenuItemClick },
        // #614: companies ask SAKA for new logins from their portal (#613); shown to kullanici.olustur holders (the route's permission, #325).
        { id: "KullaniciEklemeTalepleri", label: t("KullaniciEklemeTalepleri"), link: "/Management/Firmalar/KullaniciTalepleri", parentId: "Firmalar", click: handleMenuItemClick },
      ],
    },
    // ─── SALONLAR VE KROKİLER ──────────────────────────────────
    // 2026-09-27 (backlog #234/#237): Salonlar = seçili fuarın fuar alanındaki salonlar, bağlama
    // ve plan durumları (SalonlarPage, #157). Krokiler = Alan Planı listesi (AlanPlanlariPage):
    // bu fuara bağlı salonların Alan Planı salt okunur + standları (Stand Detay / Proje).
    // WAS (artık doğru değil):
    // Kroki sayfası iki sekmeli (seçili fuarın salon krokileri + fuardan bağımsız kroki
    // çizimi); salon listesinden /fuar/salon/:salonId sayfasına inilir. Kroki motoru
    // gelene kadar sayfadaki büyük çerçeveler rezerve alandır.
    // ⛔ REZERVE: "Salonlar" (fuar geneli salon listesi) alt girişi henüz YOK — salon
    // listesi şimdilik yalnızca Kroki sayfasının ilk sekmesinde duruyor. O sayfa
    // açıldığında buraya `{ id: "Salonlar", ... }` olarak Krokiler'in ÜSTÜNE girecek.
    {
      id: "SalonlarKrokiler",
      label: t("SalonlarKrokiler"),
      icon: "bx bx-map",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsSalonlarKrokiler(!isSalonlarKrokiler);
        setIscurrentState("SalonlarKrokiler");
        updateIconSidebar(e);
      },
      stateVariables: isSalonlarKrokiler,
      subItems: [
        // Backlog #157 (2026-09-23): doldurdu — bkz. üstteki REZERVE yorumu.
        { id: "Salonlar", label: t("Salonlar"), link: "/Management/Salonlar", parentId: "SalonlarKrokiler", click: handleMenuItemClick },
        { id: "Krokiler", label: t("Krokiler"), link: "/Management/Kroki", parentId: "SalonlarKrokiler", click: handleMenuItemClick },
      ],
    },
    // ─── STANDLAR ─────────────────────────────────────────────
    // 2026-09-15: grup değil, TEK bağlantı. "Stand Yönetimi" (/Management/Stands,
    // çalışmıyordu) menüden kalktı — stand yönetimi artık listeden tıklanan stand
    // detayında yapılıyor. "Stand Yarat" da Projeler menüsünden çıkıp bu listenin
    // araç çubuğundaki butona taşındı. Projeler (Stand Listesi) aynı standların
    // EVRAK/proje durumuna bakar — ikisi bilinçli olarak ayrı başlık.
    {
      id: "Standlar",
      label: t("Standlar"),
      icon: "bx bxs-store",
      link: "/Management/Standlar",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Standlar");
        handleMenuItemClick(e);
      },
    },
    // ─── Kişiler ──────────────────────────────────────────────────────────────
    // #385 (2026-10-13): açılan grup değil, TEK bağlantı — Kişi Listesi. Eskiden altında Meslek ve Belge
    // Kuralları / Bilgi Kategorileri / Kişi Kartım (prototip) vardı: ilk ikisi Sistem Ayarları › Kişi Kuralları
    // sayfasının iki sekmesi oldu, prototip kalktı. id "Kisi" BİLİNÇLİ aynı kaldı (MainContext görünür öğe listesi).
    // Firmalar > "Personel Belgeleri İncele" BİR FİRMANIN kadrosuna bakar; bu liste fuar/sistem geneli.
    // Rehber: docs/guides/FE-PersonnelController-kimlik-meslek-guide.md
    {
      id: "Kisi",
      label: t("Kisi"),
      icon: "bx bx-id-card",
      link: "/Management/Kisi/Personeller",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Kisi");
        handleMenuItemClick(e);
      },
    },
    // ─── Kullanıcılar ─────────────────────────────────────────────────────────
    // 2026-09-15 (backlog #13 rebuild). Top-level, no subItems on purpose — filterNavDataByConfig
    // (VerticalLayouts/index.js) only filters at this level, not inside subItems, so this is the
    // only way to actually restrict visibility to admin groups; see MainContext.js's groups[1]/[2].
    {
      id: "Users",
      label: t("Users"),
      icon: "bx bx-user-circle",
      link: "/Users",
      click: handleMenuItemClick,
    },
    // ⚠ Aşağıdaki yoruma alınmış blok ARTIK GEÇERSİZ: aynı id ile canlı bir "Standlar"
    // grubu yukarıda duruyor. Düzenleme yaparken yukarıdaki bloğu kullanın.
    // ─── Standlar — yoruma alındı ─────────────────────────────────────────────
    /*
    {
      id: "Standlar",
      label: t("Standlar"),
      icon: "bx bxs-store",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsStandlar(!isStandlar);
        setIscurrentState("Standlar");
        updateIconSidebar(e);
      },
      stateVariables: isStandlar,
      subItems: [
        { id: "StandYonetimi", label: t("StandYonetimi"), link: "/Management/Stands/3", parentId: "Standlar", click: handleMenuItemClick },
      ],
    },
    */
    // ─── SAHA FORMLARI — yoruma alındı ───────────────────────────────────────
    /*
    {
      id: "SahaModulu",
      label: t("SahaModulu"),
      icon: "bx bx-map-pin",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsSahaModulu(!isSahaModulu);
        setIscurrentState("SahaModulu");
        updateIconSidebar(e);
      },
      stateVariables: isSahaModulu,
      subItems: [
        {
          id: "ISGSub",
          label: t("ISGSub"),
          link: "/#",
          parentId: "SahaModulu",
          stateVariables: isISG,
          click: function (e) { e.preventDefault(); setIsISG(!isISG); },
          subItems: [
            { id: "ISGDenetim",      label: t("ISGDenetim"),      link: "/ISG/Denetim/Standlar", parentId: "ISGSub", click: handleMenuItemClick },
            { id: "ISGUygunsuzluk",  label: t("ISGUygunsuzluk"),  link: "/ISG/Uygunsuzluk",      parentId: "ISGSub", click: handleMenuItemClick },
            { id: "ISGDOF",          label: t("ISGDOF"),           link: "/ISG/DOF",               parentId: "ISGSub", click: handleMenuItemClick },
          ],
        },
        {
          id: "ElektrikSub",
          label: t("ElektrikSub"),
          link: "/#",
          parentId: "SahaModulu",
          stateVariables: isElektrik,
          click: function (e) { e.preventDefault(); setIsElektrik(!isElektrik); },
          subItems: [
            { id: "ElektrikDenetim",     label: t("ElektrikDenetim"),     link: "/Elektrik/Denetim/Standlar", parentId: "ElektrikSub", click: handleMenuItemClick },
            { id: "ElektrikUygunsuzluk", label: t("ElektrikUygunsuzluk"), link: "/Elektrik/Uygunsuzluk",      parentId: "ElektrikSub", click: handleMenuItemClick },
            { id: "ElektrikDOF",         label: t("ElektrikDOF"),          link: "/Elektrik/DOF",               parentId: "ElektrikSub", click: handleMenuItemClick },
          ],
        },
        {
          id: "AcilDurumSub",
          label: t("AcilDurumSub"),
          link: "/#",
          parentId: "SahaModulu",
          stateVariables: isAcilDurum,
          click: function (e) { e.preventDefault(); setIsAcilDurum(!isAcilDurum); },
          subItems: [
            { id: "AcilDurumDenetim",     label: t("AcilDurumDenetim"),     link: "/AcilDurum/Denetim/Standlar", parentId: "AcilDurumSub", click: handleMenuItemClick },
            { id: "AcilDurumUygunsuzluk", label: t("AcilDurumUygunsuzluk"), link: "/AcilDurum/Uygunsuzluk",      parentId: "AcilDurumSub", click: handleMenuItemClick },
            { id: "AcilDurumDOF",         label: t("AcilDurumDOF"),          link: "/AcilDurum/DOF",               parentId: "AcilDurumSub", click: handleMenuItemClick },
          ],
        },
        {
          id: "ConstantElektrikSub",
          label: t("ConstantElektrikSub"),
          link: "/#",
          parentId: "SahaModulu",
          stateVariables: isConstantElektrik,
          click: function (e) { e.preventDefault(); setIsConstantElektrik(!isConstantElektrik); },
          subItems: [
            { id: "ConstantElektrikDenetim",     label: t("ConstantElektrikDenetim"),     link: "/ConstantElektrik/Denetim/Standlar", parentId: "ConstantElektrikSub", click: handleMenuItemClick },
            { id: "ConstantElektrikUygunsuzluk", label: t("ConstantElektrikUygunsuzluk"), link: "/ConstantElektrik/Uygunsuzluk",      parentId: "ConstantElektrikSub", click: handleMenuItemClick },
            { id: "ConstantElektrikDOF",         label: t("ConstantElektrikDOF"),          link: "/ConstantElektrik/DOF",               parentId: "ConstantElektrikSub", click: handleMenuItemClick },
          ],
        },
        {
          id: "LogisticsSub",
          label: t("LogisticsSub"),
          link: "/#",
          parentId: "SahaModulu",
          stateVariables: isLogistics,
          click: function (e) { e.preventDefault(); setIsLogistics(!isLogistics); },
          subItems: [
            { id: "LogisticsDenetim",     label: t("LogisticsDenetim"),     link: "/Logistics/Denetim/Standlar", parentId: "LogisticsSub", click: handleMenuItemClick },
            { id: "LogisticsUygunsuzluk", label: t("LogisticsUygunsuzluk"), link: "/Logistics/Uygunsuzluk",      parentId: "LogisticsSub", click: handleMenuItemClick },
            { id: "LogisticsDOF",         label: t("LogisticsDOF"),          link: "/Logistics/DOF",               parentId: "LogisticsSub", click: handleMenuItemClick },
          ],
        },
        {
          id: "JobPermissionSub",
          label: t("JobPermissionSub"),
          link: "/#",
          parentId: "SahaModulu",
          stateVariables: isJobPermission,
          click: function (e) { e.preventDefault(); setIsJobPermission(!isJobPermission); },
          subItems: [
            { id: "JobPermissionDenetim",     label: t("JobPermissionDenetim"),     link: "/JobPermission/Denetim/Standlar", parentId: "JobPermissionSub", click: handleMenuItemClick },
            { id: "JobPermissionUygunsuzluk", label: t("JobPermissionUygunsuzluk"), link: "/JobPermission/Uygunsuzluk",      parentId: "JobPermissionSub", click: handleMenuItemClick },
            { id: "JobPermissionDOF",         label: t("JobPermissionDOF"),          link: "/JobPermission/DOF",               parentId: "JobPermissionSub", click: handleMenuItemClick },
          ],
        },
        {
          id: "UygunsuzlukDetay",
          label: t("UygunsuzlukDetay"),
          link: "/Saha/UygunsuzlukDetay",
          parentId: "SahaModulu",
          click: handleMenuItemClick,
        },
      ],
    },
    */
    // ─────────────────────────────────────────────────────────────────────────
    // ─── PROJELER — Proje Evrak Yönetimi ─────────────────────────────────────
    // 2026-09-15: grup değil, TEK bağlantı. /Management/Projects artık Stand Listesi
    // (eski Proje Listesi rotadan çıktı, eski /Stands yolu buraya yönleniyor).
    // Menüden kalkanlar: Stand Konfigürasyonları ve Dekoratöre Göre Standlar
    // (kaldırıldı), Proje Özel İzinleri (listenin araç çubuğundaki düğmeden açılıyor),
    // Proje Beyanı Uyarıları (Fuarlar > Fuar Kuralları'nda "Beyan Uyarıları" sekmesi).
    {
      id: "Projeler",
      label: t("Projeler"),
      icon: "bx bx-building-house",
      link: "/Management/Projects",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("Projeler");
        handleMenuItemClick(e);
      },
    },
    // ──────────────────────────────────────────────────────────────────────────
    // ─── FORM YÖNETİMİ — bağımsız yeni üst menü ─────────────────────────────
    {
      id: "FormYonetimi",
      label: t("FormYonetimi"),
      icon: "bx bx-clipboard",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsFormYonetimi(!isFormYonetimi);
        setIscurrentState("FormYonetimi");
        updateIconSidebar(e);
      },
      stateVariables: isFormYonetimi,
      subItems: [
        {
          id: "FormListesi",
          label: t("FormListesi"),
          link: "/Management/Forms/list",
          parentId: "FormYonetimi",
          click: handleMenuItemClick,
        },
        {
          id: "HiyerarsiYonetimi",
          label: t("HiyerarsiYonetimi"),
          link: "/Management/Forms/hierarchy",
          parentId: "FormYonetimi",
          click: handleMenuItemClick,
        },
        {
          id: "DenetimFormuDoldur",
          label: t("DenetimFormuDoldur"),
          link: "/Management/Forms/doldur",
          parentId: "FormYonetimi",
          click: handleMenuItemClick,
        },
        {
          id: "DenetimKayitlari",
          label: t("DenetimKayitlari"),
          link: "/Management/Forms/instances",
          parentId: "FormYonetimi",
          click: handleMenuItemClick,
        },
        // İkinci seviye açılır grup: denetim dışı form aileleri. Her biri kendi içinde
        // sekmeli tek sayfa — eskiden ikisi de bağımsız üst menüydü.
        {
          id: "DigerFormlar",
          label: t("DigerFormlar"),
          link: "/#",
          // setIscurrentState BURADA ÇAĞRILMAZ: bu bir alt grup, aktif üst menü hâlâ
          // Form Yönetimi. "DigerFormlar" yazsaydık yukarıdaki efekt Form Yönetimi'ni
          // kapatır, tıklayınca menü komple kapanırdı.
          click: function (e) {
            e.preventDefault();
            setIsDigerFormlar(!isDigerFormlar);
            setIscurrentState("FormYonetimi");
          },
          stateVariables: isDigerFormlar,
          subItems: [
            {
              id: "SerbestFormlar",
              label: t("SerbestFormlar"),
              link: "/Management/FreeForm",
              parentId: "DigerFormlar",
              click: handleMenuItemClick,
            },
            {
              id: "SurdurulebilirlikFormu",
              label: t("SurdurulebilirlikFormu"),
              link: "/Management/Sustainability",
              parentId: "DigerFormlar",
              click: handleMenuItemClick,
            },
            {
              id: "TadilatTalepAdmin",
              label: t("TadilatTalepAdmin"),
              link: "/Management/TadilatTalep",
              parentId: "DigerFormlar",
              click: handleMenuItemClick,
            },
          ],
        },
      ],
    },
    // ─── DENETİM FORMLARI — 2026-09-12'de kaldırıldı: üç alt girişi (Kontrol Formu /
    // Uygunsuzluk Formu / DÖF) artık Form Yönetimi > "Denetim Formu Doldur" sayfasının
    // sekmeleri (/Management/Forms/doldur). Kendi /FdsSaha rotaları duruyor — saha
    // ana sayfasındaki kısayollar oradan geçiyor. ────────────────────────────
    // ─── ÖZEL FORMLAR — yoruma alındı (ileride açılabilir) ──────────────────
    /*
    {
      id: "OzelFormlar",
      label: t("OzelFormlar"),
      icon: "bx bx-file-blank",
      link: "/FdsSaha/Formlar/ozel",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("OzelFormlar");
        handleMenuItemClick(e);
      },
    },
    */
    // ─── İSTATİSTİKLER — 2026-09-12: eski "Diğer Formlar" (FdsSaha) grubunun tek
    // üyesiydi; grup kaldırıldı, sayfa bağımsız üst menü öğesi oldu. ─────────────
    {
      id: "FdsIstatistikler",
      label: t("FdsIstatistikler"),
      icon: "bx bx-bar-chart-alt-2",
      link: "/FdsSaha/Istatistikler",
      click: function (e) {
        setIscurrentState("FdsIstatistikler");
        handleMenuItemClick(e);
      },
    },
    // ──────────────────────────────────────────────────────────────────────────
    // ──────────────────────────────────────────────────────────────────────────
    // ─── TALEP-TADİLAT — 2026-09-12'de kaldırıldı: tek girişi (Tadilat Talep
    // Başvuruları) artık Form Yönetimi > Diğer Formlar altında. ───────────────
    // ──────────────────────────────────────────────────────────────────────────
    // ─── SİSTEM AYARLARI — menünün en altı, kasten göze çarpmayan yer ────────
    // Global kural ŞABLONU burada. Fuar Kuralları (Fuarlar altında) günlük iştir;
    // şablona dokunmak bundan sonra açılacak HER fuarı etkileyen nadir bir iştir.
    // İkisini yan yana koymak, yanlış kapsamda kaydetmeyi tek tık uzağa taşıyordu.
    // ─── E-POSTA (#585, Bilge) — e-posta kayıtları, şablonlar, posta listeleri ve kendi hesaplarım tek menüde. ─────────────
    // Alt öğeler kendi rotalarının iznine göre görünür: dördü de (Kayıtlar, Şablonlar, Posta listeleri, Hesaplarım) her personele açıktır (Bilge, #585:
    // Kayıtlar ve Şablonlar eskiden page.sistem isterdi). SMTP hesapları (E-posta Hesapları) sistem ayarı olarak Sistem Ayarları'nda kaldı.
    {
      id: "EmailMenusu",
      label: t("EmailMenusu"),
      icon: "bx bx-envelope",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsEmailMenusu(!isEmailMenusu);
        setIscurrentState("EmailMenusu");
        updateIconSidebar(e);
      },
      stateVariables: isEmailMenusu,
      subItems: [
        { id: "EmailKayitlari", label: t("EmailKayitlari"), link: "/EmailLogs", parentId: "EmailMenusu", click: handleMenuItemClick },
        { id: "EmailSablonlari", label: t("EmailSablonlari"), link: "/EmailTemplates", parentId: "EmailMenusu", click: handleMenuItemClick },
        { id: "EmailListeleri", label: t("EmailListeleri"), link: "/EmailListeleri", parentId: "EmailMenusu", click: handleMenuItemClick },
        { id: "EmailHesaplarim", label: t("EmailHesaplarim"), link: "/EmailHesaplarim", parentId: "EmailMenusu", click: handleMenuItemClick },
      ],
    },
    {
      id: "SistemAyarlari",
      label: t("SistemAyarlari"),
      icon: "bx bx-cog",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIsSistemAyarlari(!isSistemAyarlari);
        setIscurrentState("SistemAyarlari");
        updateIconSidebar(e);
      },
      stateVariables: isSistemAyarlari,
      subItems: [
        {
          id: "GlobalKurallar",
          label: t("GlobalKurallar"),
          link: "/Management/Projects/GlobalRules",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #385: meslek belge kuralları + kişi künye bilgileri (eskiden Kişiler'in altındaki iki ekran), iki sekme.
        {
          id: "KisiKurallari",
          label: t("KisiKurallari"),
          link: "/Management/Kisi/Kurallar",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #243: kroki / plan ayarları (Stand Detay › Konum kenar payları).
        {
          id: "PlanAyarlari",
          label: t("PlanAyarlari"),
          link: "/Management/SistemAyarlari/Plan",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #162: yükleme kategorisi başına boyut ve uzantılar.
        {
          id: "DosyaAyarlari",
          label: t("DosyaAyarlari"),
          link: "/Management/SistemAyarlari/Dosya",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #199: kayıt kuralları (vergi numarası, firma belge doğrulaması), Yönetim / Firma ayrı.
        {
          id: "KayitAyarlari",
          label: t("KayitAyarlari"),
          link: "/Management/SistemAyarlari/Kayit",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #158: file_type kataloğu (Veri Ayarları).
        {
          id: "DosyaTurleri",
          label: t("DosyaTurleri"),
          link: "/Management/SistemAyarlari/DosyaTurleri",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #259: firmanın indirdiği boş formlar ve örnekler (document_template).
        {
          id: "BelgeSablonlari",
          label: t("BelgeSablonlari"),
          link: "/Management/SistemAyarlari/BelgeSablonlari",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #536: onay metinleri (KVKK, giriş / denetim kuralları, taahhütnameler), sürüm sürüm, TR / EN.
        {
          id: "OnayMetinleri",
          label: t("OnayMetinleri"),
          link: "/Management/SistemAyarlari/OnayMetinleri",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #159: firma_type kataloğu (Veri Ayarları).
        {
          id: "FirmaTurleri",
          label: t("FirmaTurleri"),
          link: "/Management/SistemAyarlari/FirmaTurleri",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #337: veritabanındaki adların İngilizcesi ne kadar tamam (Dosya / Firma Türleri ile aynı yetki).
        {
          id: "Ceviriler",
          label: t("Ceviriler"),
          link: "/Management/SistemAyarlari/Ceviriler",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #6: roller, yetkiler ve kök devri — yalnızca kök kullanıcı (MainContext group 1).
        {
          id: "YetkiYonetimi",
          label: t("YetkiYonetimi"),
          link: "/Management/SistemAyarlari/Yetkiler",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #411: firma portalının arayüz setleri ve modül tavanları (portal.arayuz.manage; rota izne göre açılır).
        {
          id: "PortalArayuzleri",
          label: t("PortalArayuzleri"),
          link: "/Management/SistemAyarlari/PortalArayuzleri",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #417: portal rolleri (portal.rol.manage) ve Yetki Açıklayıcı (page.firma, salt okunur).
        {
          id: "PortalRolleri",
          label: t("PortalRolleri"),
          link: "/Management/SistemAyarlari/PortalRolleri",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #538: portal Ana Sayfa'sındaki "İletişim" widget'ının kişileri (page.sistem; yazma iletisim_kisisi.manage).
        {
          id: "IletisimKisileri",
          label: t("IletisimKisileri"),
          link: "/Management/SistemAyarlari/IletisimKisileri",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        {
          id: "YetkiAciklayici",
          label: t("YetkiAciklayici"),
          link: "/Management/SistemAyarlari/YetkiAciklayici",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // Backlog #160: e-posta hesapları / kayıtları / şablonları — FDS-Backend EmailController.
        // Rotalar eskiden vardı (roller [1,2,3]) ama menüde yoktu; menüde Admin + kök (MainContext).
        {
          id: "EmailHesaplari",
          label: t("EmailHesaplari"),
          link: "/EmailConfigs",
          parentId: "SistemAyarlari",
          click: handleMenuItemClick,
        },
        // #637 (backend #636): SMS sayfaları — Hesaplar, Gönderen Adları, Şablonlar, Kayıtlar, Bakiye ve Ayarlar. Her biri kendi rotasının page.sistem izniyle gösterilir (#325).
        { id: "SmsHesaplari", label: t("SmsHesaplari"), link: "/Management/SistemAyarlari/Sms/Hesaplar", parentId: "SistemAyarlari", click: handleMenuItemClick },
        { id: "SmsGonderenAdlari", label: t("SmsGonderenAdlari"), link: "/Management/SistemAyarlari/Sms/GonderenAdlari", parentId: "SistemAyarlari", click: handleMenuItemClick },
        { id: "SmsSablonlari", label: t("SmsSablonlari"), link: "/Management/SistemAyarlari/Sms/Sablonlar", parentId: "SistemAyarlari", click: handleMenuItemClick },
        { id: "SmsKayitlari", label: t("SmsKayitlari"), link: "/Management/SistemAyarlari/Sms/Kayitlar", parentId: "SistemAyarlari", click: handleMenuItemClick },
        { id: "SmsBakiye", label: t("SmsBakiye"), link: "/Management/SistemAyarlari/Sms/Bakiye", parentId: "SistemAyarlari", click: handleMenuItemClick },
        // #643 (backend #642): SMS duyuruları — yalnız sms.duyuru.gonder iznini taşıyana görünür (rotanın izni, #325).
        { id: "SmsDuyurulari", label: t("SmsDuyurulari"), link: "/Management/SistemAyarlari/Sms/Duyurular", parentId: "SistemAyarlari", click: handleMenuItemClick },
        // WAS (until #585): E-posta Şablonları ve E-posta Kayıtları burada duruyordu; ikisi artık E-posta menüsünde (EmailMenusu).
        // {
        //   id: "EmailSablonlari",
        //   label: t("EmailSablonlari"),
        //   link: "/EmailTemplates",
        //   parentId: "SistemAyarlari",
        //   click: handleMenuItemClick,
        // },
        // {
        //   id: "EmailKayitlari",
        //   label: t("EmailKayitlari"),
        //   link: "/EmailLogs",
        //   parentId: "SistemAyarlari",
        //   click: handleMenuItemClick,
        // },
      ],
    },
    // ──────────────────────────────────────────────────────────────────────────
    // ─── BetterStandsNew — yoruma alındı ─────────────────────────────────────
    /*
    {
      id: "BetterStandsNew",
      label: t("BetterStandsNew"),
      icon: "bx bx-store-alt",
      link: "/#",
      click: function (e) {
        e.preventDefault();
        setIscurrentState("BetterStandsNew");
      },
    },
    */
    // ─── İleride kullanılacak – şimdilik menüden pasif ────────────────────────
    // {
    //   id: "BetterStands",
    //   label: "BetterStands",
    //   icon: "bx bx-chip",
    //   link: "/#",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsBetterStands(!isBetterStands);
    //     setIscurrentState("BetterStands");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isBetterStands,
    //   subItems: [
    //     { id: "Standlar", label: "Standlar", link: "/BTSArea",    parentId: "BetterStands", click: handleMenuItemClick },
    //     { id: "Reports",  label: "Raporlar", link: "/BTSReports", parentId: "BetterStands", click: handleMenuItemClick },
    //   ],
    // },
    // ──────────────────────────────────────────────────────────────────────────
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
